/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InactiveCleanupCriteriaDTOFromJSON, InactiveCleanupCriteriaDTOToJSON, } from './InactiveCleanupCriteriaDTO';
/**
 * Check if a given object implements the InactiveCleanupCandidatesRequestDTO interface.
 */
export function instanceOfInactiveCleanupCandidatesRequestDTO(value) {
    if (!('criteria' in value) || value['criteria'] === undefined)
        return false;
    return true;
}
export function InactiveCleanupCandidatesRequestDTOFromJSON(json) {
    return InactiveCleanupCandidatesRequestDTOFromJSONTyped(json, false);
}
export function InactiveCleanupCandidatesRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'criteria': InactiveCleanupCriteriaDTOFromJSON(json['criteria']),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}
export function InactiveCleanupCandidatesRequestDTOToJSON(json) {
    return InactiveCleanupCandidatesRequestDTOToJSONTyped(json, false);
}
export function InactiveCleanupCandidatesRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'criteria': InactiveCleanupCriteriaDTOToJSON(value['criteria']),
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}
